<template>
  <div class="stats">
    <h2>
      <span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_2845_1727"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_2845_1727)">
            <path
              d="M18.5769 8.76535C18.1537 9.18702 17.6678 9.50718 17.1191 9.72583C16.5705 9.94448 16.0173 10.0538 15.4597 10.0538C14.902 10.0538 14.3542 9.94771 13.8164 9.73553C13.2786 9.52336 12.7975 9.19997 12.3731 8.76535L10.4981 6.89035C10.2244 6.6147 9.91406 6.40797 9.56726 6.27015C9.22048 6.13234 8.86456 6.06343 8.49951 6.06343C8.13448 6.06343 7.77869 6.13234 7.43214 6.27015C7.0856 6.40797 6.77553 6.6147 6.50193 6.89035L4.80004 8.58263L3.73083 7.51343L5.42314 5.81153C5.849 5.38716 6.33008 5.06889 6.86636 4.85673C7.40264 4.64454 7.94681 4.53845 8.49886 4.53845C9.05093 4.53845 9.59128 4.64454 10.1199 4.85673C10.6485 5.06889 11.1259 5.38716 11.5519 5.81153L13.4269 7.68653C13.7183 7.97966 14.037 8.19494 14.383 8.33235C14.729 8.46975 15.0879 8.53845 15.4597 8.53845C15.8315 8.53845 16.1911 8.46954 16.5385 8.33173C16.8859 8.19389 17.2058 7.97883 17.4981 7.68653L19.2 5.99423L20.2692 7.06343L18.5769 8.76535ZM18.5769 13.4769C18.1522 13.9012 17.6684 14.2195 17.1257 14.4317C16.5829 14.6438 16.0327 14.7499 15.475 14.7499C14.9174 14.7499 14.3671 14.6438 13.8244 14.4317C13.2816 14.2195 12.7979 13.9012 12.3731 13.4769L10.4981 11.6019C10.2244 11.3262 9.91406 11.1195 9.56726 10.9817C9.22048 10.8438 8.86456 10.7749 8.49951 10.7749C8.13448 10.7749 7.77869 10.8438 7.43214 10.9817C7.0856 11.1195 6.77553 11.3262 6.50193 11.6019L4.80004 13.2942L3.73083 12.25L5.42314 10.5231C5.849 10.0987 6.33008 9.78041 6.86636 9.56823C7.40264 9.35606 7.94681 9.24998 8.49886 9.24998C9.05093 9.24998 9.59128 9.35606 10.1199 9.56823C10.6485 9.78041 11.1259 10.0987 11.5519 10.5231L13.4269 12.3981C13.7164 12.6912 14.033 12.9065 14.3767 13.0439C14.7205 13.1813 15.0782 13.25 15.45 13.25C15.8218 13.25 16.1831 13.1811 16.5337 13.0432C16.8843 12.9054 17.2058 12.6904 17.4981 12.3981L19.2 10.7058L20.2692 11.775L18.5769 13.4769ZM18.5519 18.1884C18.1275 18.6127 17.6479 18.931 17.1134 19.1432C16.5788 19.3554 16.0327 19.4615 15.475 19.4615C14.9174 19.4615 14.367 19.3538 13.8241 19.1384C13.2811 18.923 12.7975 18.6031 12.3731 18.1788L10.4731 16.3134C10.1994 16.0377 9.88906 15.831 9.54226 15.6932C9.19548 15.5554 8.83956 15.4865 8.47451 15.4865C8.10948 15.4865 7.75368 15.5554 7.40714 15.6932C7.0606 15.831 6.75054 16.0377 6.47693 16.3134L4.77504 18.0057L3.73083 16.9615L5.42314 15.2346C5.84784 14.8102 6.32758 14.4919 6.86238 14.2798C7.3972 14.0676 7.93988 13.9615 8.49041 13.9615C9.04418 13.9615 9.58608 14.0676 10.1161 14.2798C10.6461 14.4919 11.1248 14.8102 11.5519 15.2346L13.4269 17.1096C13.7193 17.4019 14.0391 17.6169 14.3866 17.7548C14.734 17.8926 15.0936 17.9615 15.4654 17.9615C15.8372 17.9615 16.1961 17.8928 16.5421 17.7554C16.8881 17.618 17.2068 17.4027 17.4981 17.1096L19.2 15.4173L20.2442 16.4865L18.5519 18.1884Z"
              fill="#1C1B1F"
            />
          </g>
        </svg>
      </span>
      {{ $t("stats.title") }}
    </h2>

    <div class="stats__summary">
      <div class="stats__summary-item">
        <h3>{{ $t("stats.planned_visits") }}:</h3>
        <p>
          {{
            reservations.filter((r) => r.status == ReservationStatus.Confirmed)
              .length
          }}
        </p>
      </div>
      <div class="stats__summary-item">
        <h3>{{ $t("stats.employees_on_site") }}:</h3>
        <p>{{ getWorkingEmployeesToday }}</p>
      </div>
      <div class="stats__summary-item">
        <h3>{{ $t("stats.not_confirmed_visits") }}:</h3>
        <p>{{ unconfirmedReservationsCount }}</p>
      </div>
      <div class="stats__summary-item">
        <h3>{{ $t("feedbacks") }}:</h3>
        <p>{{ companyStore.currentCompany?.feedbacks_count }}</p>
      </div>
    </div>

    <div class="stats__team-workload">
      <h3>{{ $t("stats.team_load") }}</h3>
      <ul>
        <li v-for="employee in companyStore.employees">
          <div class="team-workload__item">
            <VAvatar color="grey">
              <VImg
                :src="employee.avatar as string"
                :alt="employee.name"
                v-if="employee.avatar"
              />
              <VIcon icon="mdi-account" v-else></VIcon>
            </VAvatar>
            <div class="team-workload__item-text">
              <p>{{ employee.name }}</p>
              <p>
                {{ $t("stats.planned_visits") }}:
                {{ getEmployeesReservationsCount(employee) }}
              </p>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useCompanyStore } from "../stores/company.store";
import { Employee } from "../types/employee.type";
import { Reservation, ReservationStatus } from "../types/reservation.type";

const companyStore = useCompanyStore();

const props = defineProps<{
  reservations: Reservation[];
  unconfirmedReservationsCount: number;
}>();

const getEmployeesReservationsCount = (employee: Employee) => {
  return props.reservations.filter((reservation) =>
    reservation.employees.some((e) => e.id === employee.id)
  ).length;
};

const getWorkingEmployeesToday = computed(() => {
  return companyStore.employees.filter((employee) =>
    employee.schedules_attributes?.some((schedule) => {
      const today = new Date();
      // debugger;

      //opens_at it's hour and minutes only (e.g. "14:30") and weekday is number from 0 to 6 (0 - Sunday, 1 - Monday, ..., 6 - Saturday)
      console.log(
        employee.name,
        schedule.weekday === today.getDay(),
        (schedule.weekday === today.getDay() &&
          schedule.opens_at &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getDate() === today.getDate() &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getMonth() === today.getMonth() &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getFullYear() === today.getFullYear()) ||
          (schedule.custom_available_start &&
            new Date(schedule.custom_available_start).getDate() ===
              today.getDate() &&
            new Date(schedule.custom_available_start).getMonth() ===
              today.getMonth() &&
            new Date(schedule.custom_available_start).getFullYear() ===
              today.getFullYear())
      );

      return (
        (schedule.weekday === today.getDay() &&
          schedule.opens_at &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getDate() === today.getDate() &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getMonth() === today.getMonth() &&
          new Date(
            `${today.toISOString().split("T")[0]}T${schedule.opens_at}`
          ).getFullYear() === today.getFullYear()) ||
        (schedule.custom_available_start &&
          new Date(schedule.custom_available_start).getDate() ===
            today.getDate() &&
          new Date(schedule.custom_available_start).getMonth() ===
            today.getMonth() &&
          new Date(schedule.custom_available_start).getFullYear() ===
            today.getFullYear())
      );
    })
  ).length;
});
</script>

<style lang="scss" scoped>
.stats {
  padding: 10px 20px;
  overflow: scroll;
  height: 100%;

  h2 {
    font-family: "Poppins", sans-serif;
    text-align: left;
    font-weight: 600;
    font-size: 18px;
    line-height: 200%;
    color: #1f2937;
    margin-bottom: 20px;
  }

  h3 {
    font-weight: 500;
    font-size: 12px;
    letter-spacing: -0.01em;
    color: rgba(0, 0, 0, 0.7);
  }

  &__summary {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    margin-bottom: 20px;

    &-item {
      border: 0.92px solid #eff0f6;
      border-radius: 18px;
      background: #e7eaee;
      padding: 14px;
      font-family: "Inter", sans-serif;

      p {
        font-weight: 700;
        font-size: 24px;
        color: #000;
      }
    }
  }

  &__team-workload {
    h3 {
      font-weight: 500;
      font-size: 12px;
      letter-spacing: -0.01em;
      color: rgba(0, 0, 0, 0.7);
      margin-bottom: 10px;
    }

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 0.92px solid #eff0f6;
        border-radius: 18px;
        background: #e7eaee;
        padding: 14px;
        font-family: "Inter", sans-serif;
        margin-bottom: 10px;
        width: 100%;

        p {
          font-weight: 500;
          font-size: 14px;
          color: #000;
          word-wrap: break-word;
        }
      }
    }
  }

  .team-workload__item {
    display: flex;
    align-items: center;
    gap: 10px;

    p {
      margin: 0;
      font-family: "Inter", sans-serif;
      font-weight: 500;
      font-size: 11px;
      color: rgba(0, 0, 0, 0.5);

      &:first-of-type {
        font-weight: 600;
        font-size: 12px;
        line-height: 129%;
        color: #000;
      }
    }
  }
}
</style>
